<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import CustomLoader from "@/components/widgets/custom-loader";
import CustomFilter from "@/components/widgets/custom-filter";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Marks Filters",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CustomLoader,
    CustomFilter,
  },
  data() {
    return {
      title: "Mark Filters",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Marks Filters",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "student",
          label: "Student's Name",
          sortable: true,
        },
        {
          key: "stream",
          label: "Stream",
          sortable: true,
        },
        {
          key: "subjects",
          label: "Subjects",
          sortable: true,
        },
      ],
      allMarks: {
        class: "",
        term: "",
        year: "",
        stream: 0,
      },
    };
  },
  computed: {
    ...mapGetters("marks", [
      "SaveStatus",
      "getAllMarksFilters",
      "getCurrentClass",
      "getYears",
    ]),
    ...mapGetters("classes", ["AllClasses", "AllClassStreams"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.getAllMarksFilters.length
        ? this.getAllMarksFilters.length
        : 1;
    },
  },
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        this.resetError();
        // this.closeModal(this.modal);
      }
    },
    getAllMarksFilters(newVal) {
      if (!newVal) {
        // router.push("/marks");
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows =
      this.getAllMarksFilters.length > 0 ? this.getAllMarksFilters.length : 1;
  },
  methods: {
    ...mapActions({
      FetchMarksFilters: "marks/fetchMarksFilters",
      FetchYears: "marks/fetchYear",
      FetchClasses: "classes/fetchClasses",
      FetchClassStreams: "classes/fetchClassStreams",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.getAllMarksFilters.length
        ? this.getAllMarksFilters.length
        : 1;
      this.currentPage = 1;
    },

    fetchStreamsinClass(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class streams
      this.FetchClassStreams(classSelected);
    },

    submitFilter() {
      this.FetchMarksFilters(this.allMarks);
    },

    resetError() {
      this.nameError = "";
    },
  },
  created() {
    this.FetchYears();
    this.FetchClasses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <CustomFilter>
        <form @submit.prevent="submitFilter()">
          <div class="row">
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Year <span class="text-danger">*</span></label
                >
                <select
                  class="form-control form-control-sm"
                  v-model="allMarks.year"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Year</option>
                  <option
                    v-for="(schyear, index) in getYears"
                    :value="schyear.year"
                    :key="index"
                  >
                    {{ schyear.year }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Class <span class="text-danger">*</span></label
                >
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="allMarks.class"
                  @change="fetchStreamsinClass($event)"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Class</option>
                  <option
                    v-for="(classes, index) in AllClasses"
                    :key="index"
                    :value="classes.id"
                  >
                    {{ classes.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Term <span class="text-danger">*</span></label
                >
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="allMarks.term"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Term</option>
                  <option value="1">Term 1</option>
                  <option value="2">Term 2</option>
                  <option value="3">Term 3</option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-3">
              <div class="form-group">
                <label for=""
                  >Select Stream
                  <small class="text-primary">(Optional)</small></label
                >
                <select
                  class="form-control form-control-sm"
                  v-model="allMarks.stream"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Stream</option>
                  <option
                    v-for="(stream, index) in AllClassStreams"
                    :value="stream.id"
                    :key="index"
                  >
                    {{ stream.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3 mt-3">
              <button
                type="submit"
                size="sm"
                disabled
                class="btn btn-sm btn-outline-primary mt-2"
                v-if="SaveStatus"
              >
                <b-spinner
                  variant="primary"
                  small
                  label="Fetching Data..."
                ></b-spinner>
                Fetching Data...
              </button>
              <button
                v-else
                type="submit"
                size="sm"
                class="btn btn-sm btn-outline-primary mt-2"
              >
                <i class="fa fa-check"></i>
                Submit Filers
              </button>
            </div>
          </div>
        </form>
      </CustomFilter>
      <CustomLoader v-if="SaveStatus"></CustomLoader>
      <div class="col-12" v-else>
        <div class="card" v-if="getAllMarksFilters">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  Exam Marks For Term:
                  <b
                    ><u> {{ allMarks.term }}</u></b
                  >
                  Class:
                  <b
                    ><u> {{ getCurrentClass.short }}</u></b
                  >
                  Year:
                  <b
                    ><u> {{ allMarks.year }}</u></b
                  >
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-md-12 mt-4 custom-vert">
                    <div class="row mt-2">
                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_length"
                          class="dataTables_length"
                        >
                          <label class="d-inline-flex align-items-center">
                            Show&nbsp;
                            <b-form-select
                              class="form-select form-select-sm"
                              v-model="perPage"
                              size="sm"
                              :options="pageOptions"
                            ></b-form-select
                            >&nbsp;entries
                          </label>
                        </div>
                      </div>

                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_filter"
                          class="dataTables_filter text-md-end"
                        >
                          <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                              v-model="filter"
                              type="search"
                              placeholder="Search..."
                              class="form-control form-control-sm ms-2"
                            ></b-form-input>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive mb-0">
                      <b-table
                        class="datatables"
                        :items="getAllMarksFilters"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                      >
                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template #cell(student)="data">
                          {{ data.item.student.name }}
                        </template>
                        <template #cell(stream)="data">
                          {{ data.item.stream.name }}
                        </template>
                        <template #cell(subjects)="data">
                          <table class="table">
                            <tbody>
                              <tr>
                                <td
                                  v-for="(allSubjects, index) in data.item
                                    .subjects"
                                  :key="index"
                                >
                                  <b>{{ allSubjects.subject.short }}</b>
                                  <table
                                    class="table table-striped table-inverse"
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          v-for="(
                                            sets, index
                                          ) in allSubjects.sets"
                                          :key="index"
                                        >
                                          {{ sets.set.short }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          v-for="(
                                            marks, index
                                          ) in allSubjects.marks"
                                          :key="index"
                                        >
                                          {{ marks.marks }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </template>
                      </b-table>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div
                          class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                          "
                        >
                          <ul class="pagination pagination-rounded mb-0">
                            <b-pagination
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                            ></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-else>
          <div class="card-body">
            <div class="alert alert-primary text-center" role="alert">
              <strong>Please filter students using the above inputs.</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
